module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LSO BY "), _c('br')]), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MÉLIE ")]), _vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHOMB")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372648/tokyo-fiancee",
      "target": "_blank"
    }
  }, [_vm._v("Tokyo Fiancée")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781933372778/hygiene-and-the-assassin",
      "target": "_blank"
    }
  }, [_vm._v("Hygiene and the Assassin")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609450885/life-form",
      "target": "_blank"
    }
  }, [_vm._v("Life Form")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "https://www.europaeditions.com/book/9781609452902/petronille",
      "target": "_blank"
    }
  }, [_vm._v("Pétronille")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61668e16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/strike-your-heart_00000.vue
// module id = 60
// module chunks = 0